import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import text2image from "../../Assets/Projects/text2image.png";
import currencyconverter from "../../Assets/Projects/currency.png";
import ichat from "../../Assets/Projects/ichat.png";
import gharkaswad from "../../Assets/Projects/gharkaswad.png";
import todo from "../../Assets/Projects/todo.png";
import pinterest from "../../Assets/Projects/pinterest.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gharkaswad}
              isBlog={false}
              title="Ghar ka Swad"
              description="A food delivery system focused on home-cooked meals. This platform connects local home chefs and tiffin services with customers looking for fresh, homemade food. It also features a rider module, allowing seamless meal delivery. Developed with a user-friendly interface to enhance the customer and rider experience."
              ghLink="https://github.com/himanshu-gohel/ghar-ka-swad"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pinterest}
              isBlog={false}
              title="Pinterest Clone"
              description="Built a Pinterest clone using the MERN stack, allowing users to register, log in, update profiles, and add new posts. Implemented a dynamic feed to display posts from all users, providing an engaging exploration experience. Focused on user authentication, profile management, and post creation for an interactive social platform."
              ghLink="https://github.com/himanshu-gohel/pinterest-clone"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ichat}
              isBlog={false}
              title="Ichat Application"
              description="Developed a modern and responsive chat application using Node.js, Express, and Socket.io for real-time communication. Implemented user join/leave notifications, message broadcasting, and a custom-designed UI. The app enables seamless real-time messaging between multiple users with a clean, user-friendly interface."
              ghLink="https://github.com/himanshu-gohel/real-time-chat-app"             
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={text2image}
              isBlog={false}
              title="Text 2 Image"
              description="Created a responsive web app that generates images from text prompts using Hugging Face's API. The app features a light theme, dynamic loading animation, and adapts seamlessly to all device sizes."
              ghLink="https://github.com/himanshu-gohel/text-2-image"
              demoLink="https://generate-text-to-image.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo}
              isBlog={false}
              title="Todo App"
              description="Developed a dynamic and responsive To-Do app using React for efficient task management. Implemented features such as task addition, deletion by completion status. Utilized React hooks for state management and ensured a smooth, interactive user experience."
              ghLink="https://github.com/himanshu-gohel/react-todo-app"
              demoLink="https://react-small-todo-app.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={currencyconverter}
              isBlog={false}
              title="Currency Converter"
              description="Developed a Currency Converter that allows users to convert between different currencies with real-time exchange rates. The app features a responsive design with intuitive dropdowns and visual flags for easy selection, ensuring a seamless user experience."
              ghLink="https://github.com/himanshu-gohel/currency-converter"
              demoLink="https://webapp-currency-converter.netlify.app/"  
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
